// Read-through cache de la lista de solicitudes. Envuelve useAppApi('/solicitudes'):
// online → cachea + prefetchea las iniciadas; offline → sirve la última lista guardada.
// El hook maneja su propio `data` y `hasCalled` para que la rama offline también los refleje.
import { useCallback, useState } from 'react';
import { useAppApi } from 'hooks/useAppApi';
import { saveSolicitudes, loadSolicitudes } from 'utils/offlineSolicitudesStore';
import { prefetchMantencionesIniciadas } from 'services/prefetchMantencionesIniciadas';

export function useOfflineSolicitudes() {
  const map = useCallback((r) => r, []);
  const {
    isLoading,
    error,
    call: apiCall,
  } = useAppApi({
    baseUrl: '/solicitudes',
    mapResults: map,
  });

  const [data, setData] = useState(undefined);
  const [hasCalled, setHasCalled] = useState(false);
  const [servedFromCache, setServedFromCache] = useState(false);

  const call = useCallback(
    async (opts) => {
      setHasCalled(true);
      if (!navigator.onLine) {
        const cached = await loadSolicitudes();
        setData(cached ?? undefined);
        setServedFromCache(Boolean(cached));
        return cached;
      }
      const result = await apiCall(opts);
      if (Array.isArray(result)) {
        setData(result);
        setServedFromCache(false);
        await saveSolicitudes(result);
        prefetchMantencionesIniciadas(result); // background, no await
      } else {
        const cached = await loadSolicitudes();
        if (cached) {
          setData(cached);
          setServedFromCache(true);
        }
      }
      return result;
    },
    [apiCall]
  );

  return { data, isLoading, error, hasCalled, call, servedFromCache };
}
